import { Container, HeaderContainer, LeftSideContainer } from "./PolicyCustomizeSection.styles";
import UI from "@mile-meeting/mile-ui";
import React from "react";

type ServiceBlockProps = {
  icon?: JSX.Element;
  title?: string;
  rightChildren?: React.ReactNode;
  children?: React.ReactNode;
};

const ServiceBlock: React.FC<ServiceBlockProps> = ({ icon, title, children = <></>, rightChildren }) => {
  return (
    <Container>
      <HeaderContainer>
        <LeftSideContainer>
          {icon ? icon : <></>}
          <UI.Typography type="headline01" fontStyle="bold" color="var(--alias-color-label-normal)">
            {title}
          </UI.Typography>
        </LeftSideContainer>
        {rightChildren && rightChildren}
      </HeaderContainer>
      {children}
    </Container>
  );
};

export default React.memo(ServiceBlock);
